import { formatDMY } from '@lbcamden/shared-utils';
import { DateTime } from 'luxon';

import { PcfraDocument } from '../types/pcfra';

const revokedText = 'Revoked on';

export const hasRevokedDocument = (title: string) => title.startsWith(revokedText);

export const revokedPcfraDocumentTitle = (currentTitle: string) => {
  const newTitlePrefix = `${revokedText} ${formatDMY(DateTime.now())}`;

  return `${newTitlePrefix} - ${currentTitle}`;
};

export const getRevokedPcfraDocumentStorePatch = ({
  documentId,
  title,
}: Pick<PcfraDocument, 'documentId' | 'title'>) => ({
  documentId,
  title: revokedPcfraDocumentTitle(title),
  isActive: false,
});
